/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiIotConnectionStatus200Status =
    (typeof GetApiIotConnectionStatus200Status)[keyof typeof GetApiIotConnectionStatus200Status];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiIotConnectionStatus200Status = {
    CONNECTED: 'CONNECTED',
    DISCONNECTED: 'DISCONNECTED',
} as const;
